const isPrerendering = (): boolean => Boolean(window.__PRERENDERING__);

export const resetPrerenderStatus = (source: string): void => {
  if (!isPrerendering()) return;

  delete document.documentElement.dataset.prerenderReady;
  delete document.documentElement.dataset.prerenderError;
  document.documentElement.dataset.prerenderSource = source;
};

const afterReactPaint = (callback: () => void): void => {
  window.requestAnimationFrame(() => window.requestAnimationFrame(callback));
};

export const markPrerenderReady = (source: string): void => {
  if (!isPrerendering()) return;

  afterReactPaint(() => {
    delete document.documentElement.dataset.prerenderError;
    document.documentElement.dataset.prerenderReady = source;
  });
};

export const markPrerenderError = (source: string): void => {
  if (!isPrerendering()) return;

  delete document.documentElement.dataset.prerenderReady;
  document.documentElement.dataset.prerenderError = source;
};
